import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const RestrictedAccessGuard = ({ children }) => {
  const { user } = useSelector((state) => state.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (user.is_main_vendor) {
    return children;
  }
  const userPermissions = user?.permissions || [];
  
  const dealPermissions = [
    "View_Deals",
    "Create_Offer", 
    "Edit_Offer", 
    "Delete_Offer", 
    "Blast_Deal"
  ];
  
  const otherPermissions = [
    "View_Partners",
    "Create_Partner", 
    "Edit_Partner", 
    "Delete_Partner",
    "Redeem_Offers",
    "Redeem_Edit",
    "Redeem_Delete",
    "View_Reports_Analytics",
    "View_Subscription",
    "Purchase_Subscription",
    "View_Subscription_History",
    "Role_View",
    "Role_Create",
    "Role_Edit",
    "Role_Delete"
  ];
  
  const hasOnlyDealPermissions = userPermissions.length > 0 && 
    userPermissions.every(perm => dealPermissions.includes(perm)) &&
    !userPermissions.some(perm => otherPermissions.includes(perm));
  
  if (hasOnlyDealPermissions) {
    const currentPath = location.pathname;
    
    if (currentPath === "/campaigns/senders" && !userPermissions.includes("Blast_Deal")) {
      return <Navigate to="/dashboard" replace />;
    }
    
    if (currentPath.startsWith("/deal/campaigns/create/") && !userPermissions.includes("Blast_Deal")) {
      return <Navigate to="/dashboard" replace />;
    }
    
    if (currentPath.startsWith("/deal/campaigns/edit/") && !userPermissions.includes("Blast_Deal")) {
      return <Navigate to="/dashboard" replace />;
    }
    
    if (currentPath === "/deal/campaigns" && !userPermissions.includes("Blast_Deal")) {
      return <Navigate to="/dashboard" replace />;
    }
    
    const allowedPaths = [
      "/offers", 
      "/offers/new",
      "/offers/edit",
      "/deal/blast",
      "/deal/campaigns/blast",
      "/dashboard", 
      "/"
    ];
    
    const isAllowed = allowedPaths.some(path => 
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
    
    if (isAllowed) {
      return children;
    }
    
    if (currentPath === "/subscription" && userPermissions.includes("View_Subscription")) {
      return children;
    }
    
    if (currentPath === "/pricing" && userPermissions.includes("Purchase_Subscription")) {
      return children;
    }
    
    if (currentPath === "/payment-history" && userPermissions.includes("View_Subscription_History")) {
      return children;
    }
    
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RestrictedAccessGuard;
